module.exports = __webpack_public_path__ + "img/gallery-bailey3.95686e92.jpg";